import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-test-email',
  templateUrl: './test-email.component.html',
  styleUrls: ['./test-email.component.scss'],
})
export class TestEmailComponent extends BaseCtl {
  appId: number = 0;
  templateOptions: any[] = [];
  emailOptions: string[] = [];
  status: String = 'queue';

  // Holds current form data (for add/edit)
  testemail: any = {
    data: {
      fromEmail: '',
      to: '',
      cc: '',
      bcc: '',
      subject: '',
      message: '',
      template: '',
    },
  };

  constructor(locator: ServiceLocatorService, route: ActivatedRoute) {
    //  pass endpoint + required services to BaseListCtl
    super('applicationConfiguration', locator, route);
    let _self = this;
    _self.appId = Number(this.route.snapshot.paramMap.get('appId'));
    // _self.form.searchParams['appId'] = _self.applicationId;

    _self.getEmailConfig();
    _self.getAllTemplate();
  }

  sendMailWithoutTemplate(form: NgForm) {
    const data = this.testemail.data;
     if (!data.fromEmail || !data.toEmail || !data.subject || !data.message) {
      alert('Please fill all required fields for send email.');
       return;
  }

     if (!this.validateEmail(this.testemail.data.toEmail)) {
       alert('Invalid To Email');
       return;
     }

     if (!this.validateMultipleEmails(this.testemail.data.ccEmail)) {
       alert('Invalid CC Email(s)');
       return;
     }

     if (!this.validateMultipleEmails(this.testemail.data.bccEmail)) {
       alert('Invalid BCC Email(s)');
       return;
     }

    if (!this.appId) {
      alert('Application ID is missing!');
      return;
    }

    const payload = {
      appId: this.appId,
      fromEmail: this.testemail.data.fromEmail,
      toEmail: this.testemail.data.toEmail,
      ccEmail: this.testemail.data.ccEmail,
      bccEmail: this.testemail.data.bccEmail,
      subject: this.testemail.data.subject,
      message: this.testemail.data.message,
    };

    const url =
      this.locator.config.get('endpoint.applicationconfiguration') +
      '/testemailconfiguration';

    console.log('Sending payload to backend:', payload);

    this.locator.http.post(url, payload, (res: any, error: any) => {
      if (error) {
        console.error('Error sending test email:', error);
        alert('Error: ' + error.message);
        return;
      }

      alert(res?.message || 'Email sent successfully.');

      // Clear model explicitly with empty values
      this.testemail.data = {
        fromEmail: '',
        toEmail: '',
        ccEmail: '',
        bccEmail: '',
        subject: '',
        message: '',
        template: '',
      };

      // Reset form with default values to restore placeholders
      form.resetForm({
        fromEmail: '',
        toEmail: '',
        ccEmail: '',
        bccEmail: '',
        subject: '',
        message: '',
        template: '',
      });
    });
  }

  sendMailWithTemplate(form: NgForm) {
     const data = this.testemail.data;

    if (!data.fromEmail || !data.toEmail || !data.template) {
    alert('Please fill all required fields for template email.');
    return;
  }
    
     if (!this.validateEmail(this.testemail.data.toEmail)) {
       alert('Invalid To Email');
       return;
     }

     if (!this.validateMultipleEmails(this.testemail.data.ccEmail)) {
       alert('Invalid CC Email(s)');
       return;
     }

     if (!this.validateMultipleEmails(this.testemail.data.bccEmail)) {
       alert('Invalid BCC Email(s)');
       return;
     }

    if (!this.appId) {
      alert('Application ID is missing!');
      return;
    }

    const payload = {
      appId: this.appId,
      fromEmail: this.testemail.data.fromEmail,
      toEmail: this.testemail.data.toEmail,
      ccEmail: this.testemail.data.ccEmail,
      bccEmail: this.testemail.data.bccEmail,
      template: this.testemail.data.template.id,
    };

    const url =
      this.locator.config.get('endpoint.applicationconfiguration') +
      '/testemailwithtemplate';

    this.locator.http.post(url, payload, (res: any, error: any) => {
      if (error) {
        console.error('Error sending test email:', error);
        alert('Error: ' + error.message);
        return;
      }

      alert(res?.message || 'Email sent successfully.');

      // Clear form
      this.testemail.data = {
        fromEmail: '',
        toEmail: '',
        ccEmail: '',
        bccEmail: '',
        template: '',
      };

      // Reset form with default values to restore placeholders
      form.resetForm({
        fromEmail: '',
        toEmail: '',
        ccEmail: '',
        bccEmail: '',
        template: '',
      });
    });
  }

  getEmailConfig() {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.applicationconfiguration')
      .then((property: string) => {
        let url =
          _self.locator.config.get('endpoint.applicationconfiguration') +
          '/getemailconfiguration/' +
          _self.appId;

        _self.locator.http.get(url, function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }

          const result = res.result?.data;
          if (!result) {
            console.error('No data returned for report');
            return;
          }

          // Prefill form
          // Fill the form data completely
          //  Correct way to set emailOptions
          if (result.smtpUser) {
            _self.emailOptions = [result.smtpUser]; // assuming smtpUser is a single email string
          }
        });
      });
  }

  getAllTemplate() {
    let _self = this;

    let url =
      _self.locator.config.get('endpoint.emailtemplate') +
      '/emailtemplatelists/' +
      _self.appId; // pass appId from component

    console.log('Fetching all email templates from:', url);
  
    _self.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        console.error('Error while fetching templates:', error);
        _self.form.error = true;
        _self.form.message = 'Failed to fetch templates!';
        return;
      }

      if (res.success) {
        console.log('Templates fetched:', res.result);
        _self.templateOptions = res.result.data; // store in component variable for UI
      } else {
        _self.form.error = true;
        _self.form.message = 'No templates found!';
      }

      setTimeout(() => {
        _self.clearMessage(_self.form);
      }, 5000);
    });
  }

  sendEmailQueue(form: NgForm) {
    let _self = this;
    const data = this.testemail.data;

    if (!data.fromEmail || !data.toEmail) {
      alert('Please fill all required fields for template email.');
      return;
    }


     if (!this.validateEmail(this.testemail.data.toEmail)) {
       alert('Invalid To Email');
       return;
     }

     if (!this.validateMultipleEmails(this.testemail.data.ccEmail)) {
       alert('Invalid CC Email(s)');
       return;
     }

     if (!this.validateMultipleEmails(this.testemail.data.bccEmail)) {
       alert('Invalid BCC Email(s)');
       return;
     }

    let url =
      _self.locator.config.get('endpoint.testemail') + '/emailsendqueue';

    let payload: any = {
      appId: this.appId,
      fromEmail: this.testemail.data.fromEmail,
      toEmail: this.testemail.data.toEmail,
      ccEmail: this.testemail.data.ccEmail,
      bccEmail: this.testemail.data.bccEmail,
      status: this.status,
    };

    if (this.testemail.data.template) {
      payload.template = this.testemail.data.template.id;
    } else {
      payload.subject = this.testemail.data.subject;
      payload.message = this.testemail.data.message;
}
    this.locator.http.post(url, payload, (res: any, error: any) => {
      if (error) {
        console.error('Error sending test email:', error);
        alert('Error: ' + error.message);
        return;
      }
      alert(res?.message || 'Email sent In Queue successfully.');

      // Reset form data
      this.testemail.data = {
        fromEmail: '',
        toEmail: '',
        ccEmail: '',
        bccEmail: '',
        subject: '',
        message: '',
        template: '',
      };

      //Reset the actual Angular form including touched state
      form.resetForm({
        fromEmail: '',
        toEmail: '',
        ccEmail: '',
        bccEmail: '',
        subject: '',
        message: '',
        template: '',
      });
    });
  }

  validateEmail(email: string): boolean {
    if (!email) return false;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email.trim());
}

  validateMultipleEmails(emails: string): boolean {
    if (!emails) return true; // allow empty CC/BCC
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emails
      .split(',')
      .map((e) => e.trim())
      .every((e) => emailRegex.test(e));
   }
}
